import * as $ from "jquery";

export function activateAnimations() {
    $(document).on('scroll', popInVisible);
    popInVisible(true);

    function popInVisible( instant ) {
        var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
        var top_of_screen = $(window).scrollTop();

        $('.pop-in').each(function () {
            const $this = $(this);
            var top_of_element = $this.offset().top;
            var bottom_of_element = $this.offset().top + $this.outerHeight();
            if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)) {
                $this.addClass('popped');
                if ( instant === true ){
                    $this.addClass('instant');
                }
            }
        })
    }
}